<template>
  <div class="modal pb-8">
    <div class="cursor-pointer text-right pt-5 pr-5">
      <iconClose @click="$emit('close')"/>
    </div>
    <div class="modal-wrapper ma-auto">
      <img class="icon mb-5" src="~@/static/custom-img/failure.png" alt="">
      <div class="modal-title mb-5">{{ $t('onboardingSpecial.filedModal.title') }}</div>
      <div class="text mb-5">{{ $t('onboardingSpecial.filedModal.text') }}</div>

      <v-sheet elevation="2" rounded class="form pt-5 pb-7 px-6">
        <cardForm ref="cardForm" @submit="changePaymentMethod"/>
      </v-sheet>

      <v-btn class="primary btn-text inner-pay mt-8" dark @click="pay">{{ $t('base.submit') }}</v-btn>
    </div>
  </div>
</template>

<script>
import cardForm from '@/components/subscription/cardForm';
import iconClose from '@/static/custom-img/close.svg';

export default {
  components: {
    cardForm,
    iconClose,
  },

  methods: {
    async changePaymentMethod ({ token }) {
      await this.$store.dispatch('user/UPDATE_PAYMENT_METHOD', token);
      this.$emit('changed');
    },

    pay () {
      this.$refs.cardForm.pay();
    },
  },
};
</script>

<style lang="scss" scoped>
.modal {
  text-align: center;
}

.modal-wrapper {
  max-width: 350px;
}

.inner-pay {
  font-weight: bold;
  font-size: 18px;
  line-height: 20px;
  align-items: center;
  text-align: center;
  letter-spacing: 0.2px;
  width: 100%;
  text-transform: none;
}

.form {
  &::v-deep {
    .pay {
      display: none;
    }
  }
}

.icon {
  width: 56px;
  height: 56px;
}

.modal-title {
  font-weight: bold;
  font-size: 26px;
  line-height: 32px;
  text-align: center;
  letter-spacing: -0.175px;
  color: #44445E;
}

.text {
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 19px;
  text-align: center;
  letter-spacing: -0.175px;
  color: #707070;
}
</style>
